let timerWorkerInstance = null;
const listeners = new Set();

/**
 * Returns the singleton timer worker instance. Creates it if not already created.
 */
export function getTimerWorkerInstance() {
  if (!timerWorkerInstance) {
    timerWorkerInstance = new Worker(new URL('./timerWorker.js', import.meta.url), { type: 'module' });
    // Forward all timer messages to registered listeners
    timerWorkerInstance.addEventListener('message', (event) => {
      console.log("YASHWANTH TimerWorker event data:", event.data);
      listeners.forEach((cb) => {
        try {
          console.log("TimerWorker event data:", event.data);
          cb(event);
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error('TimerWorker listener error:', e);
        }
      });
    });
  }
  return timerWorkerInstance;
}

/**
 * Subscribe to timer worker messages (timer updates, etc).
 * @param {function} callback - Function to call with worker event.
 * @returns {function} Unsubscribe function.
 */
export function subscribeToTimerWorker(callback) {
  listeners.add(callback);
  return () => listeners.delete(callback);
}

/**
 * Unsubscribe a callback from timer worker messages.
 * @param {function} callback
 */
export function unsubscribeFromTimerWorker(callback) {
  listeners.delete(callback);
}

/**
 * Terminate the timer worker and clear all listeners.
 */
export function terminateTimerWorker() {
  if (timerWorkerInstance) {
    timerWorkerInstance.terminate();
    timerWorkerInstance = null;
  }
  listeners.clear();
}

// Usage:
// 1. In React: use subscribeToTimerWorker in a useEffect to listen for timer updates.
// 2. In non-React JS: call subscribeToTimerWorker and handle updates as needed.
// 3. For Redux sync: In App.jsx, subscribe and dispatch timer updates to Redux.